.sidebar {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 1rem;
  border-right: solid 1px lightgrey;
  overflow: auto;
  border-width: thin;
  border-style: none;

  @media (min-width: 992px) {
    width: 265px;
  }
}

.header {
  display: flex;
}

.headerLogo {
  display: grid;
  place-items: center;
  border-radius: 0.75rem;
  background-color: #e3eef8;
  width: 3.75rem;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  padding: 0.5rem;
}

.headerLogo svg {
  width: 2.5rem;
  height: 2.5rem;
}

.headerText {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 1rem;
  line-height: 140%;
}

.headerText div:nth-child(1) {
  font-size: 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: light-dark(rgb(128, 128, 128), rgb(157, 157, 157));
}

.headerText div:nth-child(2) {
  font-size: 1.3rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: black;
}

.navGroup {
  background: #f1f1f1;
  border-radius: 0.5rem;
  padding: 0.5rem 0;
  margin: 0;
}

.nav {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  row-gap: 1rem;
}

.nav li {
  list-style: none;
}

.navItem {
  display: flex;
  position: relative;
  align-items: center;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease-in-out;
  font-size: 0.9rem;
  font-weight: 500;
  color: black;
  text-decoration: unset;
}

.navItem:hover .navItemHighlight {
  opacity: 1;
  height: 30%;
}

.navItem:global(.active) {
  font-weight: 700;
}

.navItem:global(.active) .navItemHighlight {
  opacity: 1;
  height: 40%;
}

.navItem:global(.unread)::after {
  content: '•';
  position: absolute;
  top: 0.75rem;
  right: 1rem;
  color: var(--bs-pink);
  font-size: 2rem;
  line-height: 1.2rem;
}

.navItem:global(.tasks)::after {
  content: '•';
  position: absolute;
  top: 0.75rem;
  right: 1rem;
  color: var(--bs-orange);
  font-size: 2rem;
  line-height: 1.2rem;
}

.navItemHighlight {
  position: absolute;
  left: 0;
  width: 0.25rem;
  height: 10%;
  opacity: 0;
  background-color: black;
  transition: all 0.25s ease-in-out;
}

.navItemBg {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  transition: all 0.3s ease-in-out;
  background: #f1f1f1;
}

.navItemIcon {
  width: 1.1rem;
  height: 1.1rem;
  margin-right: 0.75rem;
}

.navItemIcon img {
  vertical-align: baseline;
}

.navItemLocked {
  color: rgb(128, 128, 128);
}

.navItemLocked .navItemIcon {
  opacity: 0.75;
}

.navItemText {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
}

.navItemLabelRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.navItemSubtext {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.1rem;
}

.navItemBadge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.1rem 0.4rem;
  border: solid 1px lightgrey;
  border-radius: 0.4rem;
  white-space: nowrap;
}

.navBottom {
  padding: 0.75rem 0;
}

.navBottom img {
  width: 1.25rem;
  height: 1.25rem;
}

.navNote {
  padding: 0 1rem;
  font-size: 0.75rem;
}
